module.exports = __webpack_public_path__ + "static/media/avionBlue.caa2f6d7.svg";